import { format } from 'date-fns';
import { enGB } from 'date-fns/locale';
import useI18n from './useI18n';

export const useLocaleFormat = () => {
  const { languages, resolvedLanguage } = useI18n();
  const currentLangCode = resolvedLanguage as keyof typeof languages;
  const locale = languages?.[currentLangCode]?.locale ?? enGB;

  const formatDate = (date: Date | number, formatStr: string = 'P') => {
    return format(date, formatStr, { locale });
  };

  const getFractionDigits = (value: number) => {
    const absoluteValue = Math.abs(value);

    if (Number.isInteger(value)) return 0;

    if (absoluteValue < 10) return 2;

    if (absoluteValue < 100) return 1;

    return 0;
  };

  const formatNumber = (input: number | string) => {
    let value = input;
    let isPercentageValue = false;
    const codesRequireSpace = ['de', 'fr'];
    const space = codesRequireSpace.includes(currentLangCode) ? ' ' : '';

    if (typeof value === 'string') {
      isPercentageValue = value.includes('%');
      value = Number.parseFloat(value);
    }

    const decimals = getFractionDigits(value);

    const absoluteValue = Math.abs(value);

    if (decimals === 1 && absoluteValue > 10 && absoluteValue < 100) {
      value = Math.round(value * 10) / 10;
    }

    return (
      value.toLocaleString(currentLangCode, {
        style: 'decimal',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }) + (isPercentageValue ? space + '%' : '')
    );
  };

  return {
    formatNumber,
    formatDate,
    locale,
  };
};
